import { isNil } from 'lodash'

import { Collection } from 'modules/core/lib/mobx-rest'

import type { Automation } from 'modules/automations/store/models/Automation'
import { ExecutionHistoryEntry } from 'modules/automations/store/models/ExecutionHistoryEntry'

export class ExecutionHistoryEntriesCollection extends Collection<ExecutionHistoryEntry> {
  model() {
    return ExecutionHistoryEntry
  }

  /**
   * Gets a paginated chunk of entries, adds them, and returns the new ones.
   *
   * Calls to this method will continue the pagination since the last element.
   */
  async fetchPaginated(automation: Automation): Promise<ExecutionHistoryEntry[]> {
    const lastEntry = this.last()

    const paginationparameters = isNil(lastEntry)
      ? {}
      : {
          until_time: lastEntry.startedAt,
          until_id: lastEntry.id,
        }

    return await this.fetch({
      remove: false,
      data: {
        automation_id: automation.id,
        ...paginationparameters,
      },
    })
  }
}
